<template>
  <div class="product-item" @click="handleClick" >
    <div class="product-item__name">
      {{ product.name }}
    </div>
    <div class="product-item__title">
      Ref: {{ product.codeSupplier }}
    </div>
    <div class="quantity-button-wrap">
      <span v-if="product.quantity">
        <el-tag type="success" size="mini">Quantité réceptionnée : {{ product.quantity }}</el-tag>
      </span>
      <QuantityButton
        v-if="showQuantityButton"
        :defaultQuantity="0"
        @onValueSaved="handleQuantitySaved"
      />
    </div>
  </div>
</template>
<script>
import QuantityButton from '@/components/QuantityButton.vue';

export default {
  components: {
    QuantityButton,
  },
  props: {
    product: { type: Object },
    showQuantityButton: { type: Boolean, default: false },
  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    },
    handleQuantitySaved(quantity) {
      this.$emit('newQuantitySaved', quantity);
    },
  },
};
</script>
<style lang="stylus" scoped>
.product-item {
  background: white;
  border-radius: 3px;
  border: solid 1px whitesmoke;
  width: 100%;
  padding: 20px 10px;
  &:hover {
    background-color: #dcdcdc33;
    cursor: pointer;
  }
  &:hover .choose-user-label {
    opacity: 1;
  }
}

.choose-user-label {
  opacity:0;
  color: #969696;
}

.product-item__name, .product-item__title {
  text-align: left;
}

.product-item__name {
  color: #2f2f2f;
}
.product-item__title {
  color: #8e8e8e;
}

.quantity-button-wrap {
  float: right;
  margin-top: 10px;
}
</style>
